const finnishTemplate = {
    greeting: "Hei {{firstname}}!\n\n",
    closing: "\n\nYstävällisin terveisin,\nLea Bank",
    openingTimes: "\n\nPuhelinpalvelumme on avoinna maanantaista perjantaihin klo 9:00-16:00.",
    offer: "Luoton määrä: {{finalLoanAmount}}\nKuukausierä: {{monthlyCost}}\nTakaisinmaksuaika: {{terms}}\nTilinhoitopalkkio: {{termFee}}\nAvausmaksu: {{startupFee}}\nNimelliskorko: {{interestRate}}\nTodellinen vuosikorko: {{effectiveInterestRate}}",
};

export const communicationTemplatesFI: {
    [key: string]: {
        templateName: string;
        text: string;
        variables: string[];
        templateType?: "sms" | "mail";
    };
} = {
    GENERAL_TEMPLATE: {
        templateName: "General template",
        text: `${finnishTemplate.greeting}Linkki hakemukseesi: {{signingLink}}.\n\nJos sinulla on kysyttävää, voit ottaa yhteyttä asiakaspalveluumme: 02 4809 3850 tai asiakaspalvelu@leabank.fi.${finnishTemplate.openingTimes}\n\nHyvää päivän jatkoa!${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink"],
        templateType: "mail",
    },
    REJECTION: {
        templateName: "Rejection",
        text: `${finnishTemplate.greeting}Olemme tehneet kokonaisarvion lainahakemuksestasi, emmekä valitettavasti voi myöntää rahoitusta tällä kertaa.${finnishTemplate.closing}`,
        variables: ["firstname"],
        templateType: "mail",
    },
    PRE_APPROVAL: {
        templateName: "Pre-approval",
        text: `${finnishTemplate.greeting}Voimme tarjota sinulle seuraavaa lainaa:\n\n${finnishTemplate.offer}\n\nLinkki hakemukseesi: {{signingLink}}\n\nKun hakemus on hyväksytty, laina maksetaan ilmoittamallesi pankkitilille.\n\nJos sinulla on kysyttävää, ota yhteyttä numeroon 02 4809 3850 tai sähköpostitse asiakaspalvelu@leabank.fi.${finnishTemplate.openingTimes}${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink", "finalLoanAmount", "monthlyCost", "terms", "interestRate", "effectiveInterestRate", "startupFee", "termFee"],
        templateType: "mail",
    },
    PRE_APPROVAL_TOPUP: {
        templateName: "Pre-approval - TopUp",
        text: `${finnishTemplate.greeting}Olet hakenut meiltä korotusta lainaasi.\n\nOlemme käsitelleet hakemuksesi alustavasti ja antamiesi tietojen perusteella voimme tarjota sinulle seuraavaa:\n\n${finnishTemplate.offer}\n\nKoska sinulla voi olla Lea Bankilta vain yksi laina kerrallaan, maksamme nykyisen lainasi pois uudella lainalla ja siirrämme erotuksen tilillesi.\n\nLinkki hakemukseesi: {{signingLink}}\n\nKun hakemuksesi on käsitelty, laina siirretään ilmoittamallesi tilille, mikäli hakemustiedot pitävät paikkansa. Tarjous on voimassa 30 päivää.\n\nJos sinulla on kysyttävää, voit ottaa yhteyttä asiakaspalveluumme: 02 4809 3850 tai asiakaspalvelu@leabank.fi.${finnishTemplate.openingTimes}${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink", "finalLoanAmount", "monthlyCost", "terms", "interestRate", "effectiveInterestRate", "startupFee", "termFee"],
        templateType: "mail",
    },
    REFINANCE_LOAN: {
        templateName: "Refinance loan",
        text: `${finnishTemplate.greeting}Olet hakenut meiltä jälleenrahoitusta, mutta meiltä puuttuvat tiedot lainoista, jotka haluat rahoittaa.\n\nKirjaudu sisään alla olevan linkin kautta ja täytä tiedot nykyisistä lainoistasi, jotta voimme käsitellä hakemuksesi.\n\nLinkki hakemukseesi: {{signingLink}}\n\nKun olet viimeistellyt hakemuksesi, käsittelemme sen ja otamme sinuun yhteyttä.\n\nJos sinulla on kysyttävää, voit ottaa yhteyttä asiakaspalveluumme: 02 4809 3850 tai asiakaspalvelu@leabank.fi.${finnishTemplate.openingTimes}\n\nAutamme mielellämme sinua eteenpäin!${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink"],
        templateType: "mail",
    },
    TINK: {
        templateName: "Tink",
        text: `${finnishTemplate.greeting}Jotta voimme edetä hakemuksesi käsittelyssä, sinun pitää vahvistaa tilinumerosi turvallisesti ja nopeasti Tinkin kautta.\n\nTilinumeron vahvistus tarvitaan, jotta allekirjoitusprosessi voidaan viedä loppuun.\n\nLinkki hakemukseesi: {{signingLink}}\n\nKun olet viimeistellyt koko allekirjoitusprosessin, käsittelemme hakemuksesi ja otamme sinuun yhteyttä.\n\nTarvitsetko apua? Ota yhteyttä numeroon 02 4809 3850 tai sähköpostitse asiakaspalvelu@leabank.fi.${finnishTemplate.openingTimes}${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink"],
        templateType: "mail",
    },
    TINK_FASTER_DISBURSEMENT: {
        templateName: "Tink for faster disbursement",
        text: `${finnishTemplate.greeting}Voit valita hakemuksessasi tilinumerosi vahvistamisen Tinkin kautta, mikä nopeuttaa lainan maksua hyväksymisen jälkeen.\n\nLinkki hakemukseesi: {{signingLink}}\n\nKun olet viimeistellyt allekirjoitusprosessin, käsittelemme hakemuksesi.\n\nJos sinulla on kysyttävää, voit ottaa yhteyttä asiakaspalveluumme: 02 4809 3850 tai asiakaspalvelu@leabank.fi.${finnishTemplate.openingTimes}${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink"],
        templateType: "mail",
    },
    MISSING_ERROR_ACCOUNT_NUMBER: {
        templateName: "Missing or error in account number",
        text: `${finnishTemplate.greeting}Antamasi tilinumero on virheellinen.\n\nLähetä tilinumerosi IBAN-muodossa osoitteeseen asiakaspalvelu@leabank.fi tai soita numeroon 02 4809 3850.${finnishTemplate.openingTimes}\n\nLinkki hakemukseesi: {{signingLink}}${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink"],
        templateType: "mail",
    },
    LOAN_APPROVED_SIGN_FOR_DISBURSEMENT: {
        templateName: "No answer - Sign for disbursement",
        text: `${finnishTemplate.greeting}Yritin tavoittaa sinua puhelimitse – lainasi on hyväksytty ja ainoastaan allekirjoituksesi puuttuu enää!\n\nAllekirjoita ja nosta laina: {{signingLink}}\n\nJos sinulla on kysyttävää, ota yhteyttä: soita numeroon 02 4809 3850 ja pyydä Kimiä tai lähetä viesti osoitteeseen asiakaspalvelu@leabank.fi.\n\nYstävällisin terveisin,\nKim\nLea Bank AB\n\n* Tarjous edellyttää, että antamasi tiedot pitävät paikkansa ja ovat todennettavissa.`,
        variables: ["firstname", "signingLink"],
        templateType: "mail",
    },
    PRE_APPROVAL_SMS: {
        templateName: "Pre-approval",
        text: `${finnishTemplate.greeting}Olemme lähettäneet sinulle alustavan tarjouksen sähköpostitse. Ota yhteyttä, jos sinulla on kysyttävää hakemukseesi liittyen.\n\nLinkki hakemukseesi: {{signingLink}}${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink"],
        templateType: "sms",
    },
    CONTROL_CALL: {
        templateName: "Control call",
        text: `${finnishTemplate.greeting}Meillä on sinulle muutama nopea kysymys ennen kuin lainasi voidaan maksaa. Otathan yhteyttä numeroon 02 4809 3850, kiitos!\n\nAukioloajat: ma–pe klo 09:00–16:00.${finnishTemplate.closing}`,
        variables: ["firstname"],
        templateType: "sms",
    },
    CONTROL_CALL_INSURANCE: {
        templateName: "Control call - Insurance",
        text: `${finnishTemplate.greeting}Meillä on sinulle muutama nopea kysymys ennen kuin lainasi voidaan maksaa. Otathan yhteyttä numeroon 02 4809 3850, kiitos!\n\nAukioloajat: ma–pe klo 09:00–16:00.${finnishTemplate.closing}`,
        variables: ["firstname"],
        templateType: "sms",
    },
    MYMONEY_INSURANCE: {
        templateName: "MyMoney - Insurance call",
        text: `${finnishTemplate.greeting}Olemme yrittäneet tavoittaa sinua lainaasi liittyen. Otathan yhteyttä numeroon 02 4809 3850.\n\nAukioloajat: ma–pe klo 09:00–16:00.${finnishTemplate.closing}`,
        variables: ["firstname"],
        templateType: "sms",
    },
    TOPUP: {
        templateName: "TopUp",
        text: `${finnishTemplate.greeting}Olemme lähettäneet sinulle alustavan tarjouksen lainasi korotuksesta. Ota yhteyttä, jos sinulla on kysyttävää hakemukseesi liittyen.\n\nLinkki hakemukseesi: {{signingLink}}${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink"],
        templateType: "sms",
    },
    EMAIL_SENT: {
        templateName: "We have sent an email",
        text: `${finnishTemplate.greeting}Olemme lähettäneet sinulle sähköpostia hakemukseesi liittyen. Jos et löydä viestiä, tarkista roskaposti.\n\nHyvää päivän jatkoa!${finnishTemplate.closing}`,
        variables: ["firstname"],
        templateType: "sms",
    },
    COMPLETE_SIGNING: {
        templateName: "Complete signing",
        text: `${finnishTemplate.greeting}Tarvitsemme hieman lisätietoja, jotta voimme käsitellä hakemuksesi loppuun.\n\nJatka tästä: {{signingLink}}\n\nHyvää päivän jatkoa!${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink"],
        templateType: "sms",
    },
    MISSING_ERROR_ACCOUNT_NUMBER_SMS: {
        templateName: "Missing or error in account number",
        text: `${finnishTemplate.greeting}Antamasi tilinumero on virheellinen. Lähetä tilinumerosi IBAN-muodossa osoitteeseen asiakaspalvelu@leabank.fi tai soita numeroon 02 4809 3850.\n\nAukioloajat: ma–pe klo 09:00–16:00.\n\nLinkki hakemukseen: {{signingLink}}${finnishTemplate.closing}`,
        variables: ["firstname", "signingLink"],
        templateType: "sms",
    },
    NO_ANSWER_COMPLETE_SIGNING: {
        templateName: "No answer - Complete signing",
        text: `${finnishTemplate.greeting}Yritimme tavoittaa sinua – olet saanut meiltä lainatarjouksen, joka odottaa allekirjoituksen viemistä loppuun.\n\nSoita numeroon 02 4809 3850 (ma–pe: 09–16), niin autamme sinua eteenpäin.${finnishTemplate.closing}`,
        variables: ["firstname"],
        templateType: "sms",
    },
    NO_ANSWER_SIGN_OFFER_SMS: {
        templateName: "No answer - Sign offer",
        text: "Hei {{firstname}}! Yritin tavoittaa sinua puhelimitse. Tarjouksesi odottaa allekirjoitusta – allekirjoita helposti täällä: {{signingLink}}\n\nOnko sinulla kysyttävää? Soita 02 4809 3850.\n\nYstävällisin terveisin,\nKim\nLea Bank",
        variables: ["firstname", "signingLink"],
        templateType: "sms",
    },
};
